"use client"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { useLanguage } from "@/contexts/language-context"

/** A pending step that would affect a worker's scheduled budgeted hours changes, waiting on the reader. */
export interface ScheduledHoursConfirmation {
  title: string
  message: string
  confirmLabel: string
  onConfirm: () => void
  /** Called on Go Back, after the confirmation closes. */
  onBack?: () => void
}

export interface ScheduledHoursConfirmDialogProps {
  confirmation: ScheduledHoursConfirmation | null
  onClose: () => void
}

/** Asks before a step that cancels, or changes when, a worker's scheduled budgeted hours changes take effect. */
export const ScheduledHoursConfirmDialog = ({ confirmation, onClose }: ScheduledHoursConfirmDialogProps) => {
  const { dictionary } = useLanguage()

  return (
    <AlertDialog open={confirmation !== null} onOpenChange={open => { if (!open) onClose() }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{confirmation?.title}</AlertDialogTitle>
          <AlertDialogDescription>{confirmation?.message}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            onClick={() => {
              const back = confirmation?.onBack
              onClose()
              back?.()
            }}
          >
            {dictionary?.engagement?.workers?.goBack || "Go Back"}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={() => {
              const confirm = confirmation?.onConfirm
              onClose()
              confirm?.()
            }}
          >
            {confirmation?.confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
